import { useCurrentShopDetail } from './useCurrentShopDetail';
import { usePermissions } from '@/hooks/usePermissions';

export function useOrderAccess() {
  const { data } = useCurrentShopDetail();
  const { can } = usePermissions();
  return Boolean(data?.data?.commerce_pages_enabled) && can('sales.view');
}
